/**
 * Which string areas load together (see index.tsx). Plain data with no imports, so
 * vite.config.ts can read it too and name one chunk per language and bundle.
 */
export const BUNDLES = {
  /** Always loaded before anything renders; English `common` ships in the entry chunk. */
  core: ['common'],
  /**
   * The world's own labels (building, room wall, list): all a first visit to a building
   * reads, so a student's first page on a Chromebook doesn't wait for the Reader's strings.
   */
  world: ['world'],
  /** The rest of what a student or family sees: the Reader, the student screens, family. */
  learn: ['reader', 'student', 'family'],
  /** Teacher screens, walk screens and the projector. */
  teach: ['teacher', 'teacherWalk', 'projector'],
  /** Public pages: landing, privacy, accessibility, footer, teacher help. */
  site: ['public'],
  /** Family setup: the museum's visitor screens (front door, map, rooms, archive). */
  museum: ['museum'],
  /** Family setup: the Curator's Office. */
  office: ['office'],
  /** The Curator's Hub in the browser (family setup, level 2): /hub, /hub/pair, /visit. */
  hub: ['hub'],
} as const

export type Bundle = keyof typeof BUNDLES
